import Vue from 'vue';

export default Vue.filter('objetoACadena', function (objeto, cadenaNulo, largoMaximo, ...clavesEscritas) {
    // Validar que el objeto exista y tenga al menos una de las claves especificadas
    if (!objeto || !clavesEscritas.some(clave => objeto[clave])) {
        return cadenaNulo;
    }
    
    let cadenaFinal = "";

    // Agregar valor con espacio sin hacerlo con el último
    for (let i = 0; i < clavesEscritas.length - 1; i++) {
        const clave = clavesEscritas[i];
        // Validar que la propiedad exista antes de agregarla
        if (objeto[clave]) {
            cadenaFinal += objeto[clave] + " ";
        }
    }

    const ultimaClave = clavesEscritas[clavesEscritas.length - 1];
    // Para el último valor, agregarlo sin espacio
    if (objeto[ultimaClave]) {
        cadenaFinal += objeto[ultimaClave];
    }

    // Si después de todo no hay contenido, retornar la cadena para nulos
    if (!cadenaFinal.trim()) {
        return cadenaNulo;
    }

    // Si supera el largo máximo, agregar ellipsis
    // Cuando e llargo máximo es negativo, no se aplica restricción
    if (largoMaximo >= 0 && cadenaFinal.length > largoMaximo) {
        cadenaFinal = cadenaFinal.substring(0, largoMaximo) + "...";
    }

    return cadenaFinal.trim();
});